import { isMocking, mockedEvent, getMockSocket } from 'api/mockupUtils'
import DATA_MC_LIST from 'data/mocks/superadmin/mcList.json'
import DATA_CONFIG_FILE from 'data/mocks/superadmin/config.json'

export default socket => ({
    requestMcList: () => {
        console.tron.log('SOCKET EMMIT - superadmin_request_mc_list')
        // socket.emit(mockedEvent('superadmin_request_mc_list'), isMocking || true ? getMockSocket('superadmin_mc_list', DATA_MC_LIST) : {})
        socket.emit('superadmin_request_mc_list')
    },
    requestNewMc: data => {
        console.tron.log('SOCKET EMMIT - superadmin_request_new_mc')
        console.tron.log(data)
        // socket.emit(mockedEvent('superadmin_request_new_mc'), isMocking || true ? getMockSocket('superadmin_mc_created', { uuid: 10 + Math.round(Math.random() * 1000), username: data.username }) : {})
        socket.emit('superadmin_request_new_mc', data)
    },
    requestUpdateMc: data => {
        console.tron.log('SOCKET EMMIT - superadmin_request_mc_update')
        console.tron.log(data)
        // socket.emit(mockedEvent('superadmin_request_mc_update'), isMocking || true ? getMockSocket('superadmin_mc_updated', data) : {})
        socket.emit('superadmin_request_mc_update', data)
    },
    requestUpdateMcPassword: data => {
        console.tron.log('SOCKET EMMIT - superadmin_request_mc_update_password')
        console.tron.log(data)
        // socket.emit(mockedEvent('superadmin_request_mc_update_password'), isMocking || true ? getMockSocket('superadmin_mc_updated_password', {}) : {})
        socket.emit('superadmin_request_mc_update_password', data)
    },
    requestDeleteMc: data => {
        console.tron.log('SOCKET EMMIT - superadmin_request_mc_delete')
        console.tron.log(data)
        // socket.emit(mockedEvent('superadmin_request_mc_delete'), isMocking || true ? getMockSocket('superadmin_mc_deleted', {}) : {})
        socket.emit('superadmin_request_mc_delete', data)
    },
    requestConfigFileData: () => {
        console.tron.log('SOCKET EMMIT - superadmin_request_config_file_data')
        // socket.emit(mockedEvent('superadmin_request_config_file_data'), isMocking || true ? getMockSocket('superadmin_config_file_data', DATA_CONFIG_FILE) : {})
        socket.emit('superadmin_request_config_file_data')
    },
    requestUpdateConfigFile: json => {
        console.tron.log('SOCKET EMMIT - superadmin_request_update_config_file')
        console.tron.log(json)
        // socket.emit(mockedEvent('superadmin_request_update_config_file'), isMocking || true ? getMockSocket('superadmin_updated_config_file', json) : {})
        socket.emit('superadmin_request_update_config_file', json)
    }
})



// WEBPACK FOOTER //
// src/api/emitters/superadmin.js